interface CardItem {
  title: string;
  tag: string;
  image: string;
  imageAlt: string;
  rating: string;
  meta: string;
}

const items: CardItem[] = [
  {
    title: '逆光前行',
    tag: '热血励志',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20an%20inspirational%20sports%20drama%2C%20athlete%20running%20on%20track%20at%20sunset%2C%20warm%20golden%20lighting%2C%20dramatic%20silhouette%2C%20film%20grain%20texture%2C%20professional%20poster%20composition%2C%20dark%20background%20with%20warm%20accents&width=400&height=560&seq=card-01&orientation=portrait',
    imageAlt: '逆光前行 - 热血励志电影',
    rating: '8.7',
    meta: '剧情 / 运动',
  },
  {
    title: '深海迷踪',
    tag: '惊悚悬疑',
    image: 'https://readdy.ai/api/search-image?query=Thriller%20movie%20poster%20with%20deep%20ocean%20underwater%20scene%2C%20mysterious%20dark%20blue%20and%20teal%20tones%2C%20submerged%20structure%2C%20cinematic%20lighting%20rays%20from%20above%2C%20suspenseful%20atmosphere%2C%20professional%20film%20poster%20design&width=400&height=560&seq=card-02&orientation=portrait',
    imageAlt: '深海迷踪 - 惊悚悬疑电影',
    rating: '8.4',
    meta: '悬疑 / 惊悚',
  },
  {
    title: '花间一壶酒',
    tag: '古装爱情',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20chinese%20costume%20drama%20poster%2C%20couple%20under%20blossoming%20cherry%20tree%20in%20ancient%20garden%2C%20warm%20soft%20lighting%2C%20traditional%20elements%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20elegant%20aesthetic&width=400&height=560&seq=card-03&orientation=portrait',
    imageAlt: '花间一壶酒 - 古装爱情剧集',
    rating: '8.9',
    meta: '古装 / 爱情',
  },
  {
    title: '极速追击',
    tag: '动作犯罪',
    image: 'https://readdy.ai/api/search-image?query=Action%20crime%20thriller%20poster%20with%20car%20chase%20scene%20on%20city%20highway%20at%20night%2C%20warm%20street%20light%20reflections%2C%20dynamic%20motion%20blur%2C%20cinematic%20composition%2C%20intense%20atmosphere%2C%20professional%20film%20poster%20quality&width=400&height=560&seq=card-04&orientation=portrait',
    imageAlt: '极速追击 - 动作犯罪大片',
    rating: '8.5',
    meta: '动作 / 犯罪',
  },
  {
    title: '青春不散场',
    tag: '校园青春',
    image: 'https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%20with%20group%20of%20students%20laughing%20on%20school%20rooftop%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20film%20aesthetic%2C%20soft%20focus%2C%20cinematic%20composition%2C%20heartwarming%20atmosphere&width=400&height=560&seq=card-05&orientation=portrait',
    imageAlt: '青春不散场 - 校园青春剧',
    rating: '8.3',
    meta: '青春 / 校园',
  },
  {
    title: '末日堡垒',
    tag: '科幻灾难',
    image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci-fi%20movie%20poster%20with%20ruined%20cityscape%20and%20survivors%2C%20warm%20orange%20sky%20with%20dust%20particles%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20design%2C%20epic%20atmosphere&width=400&height=560&seq=card-06&orientation=portrait',
    imageAlt: '末日堡垒 - 科幻灾难电影',
    rating: '8.6',
    meta: '科幻 / 灾难',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热播推荐</h2>
            <p className="text-sm text-foreground-600 mt-1">精选高分影视 · 总有一部适合你</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {items.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className="group flex flex-col cursor-pointer"
              >
                <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                  <div className="absolute top-2.5 left-2.5">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-primary-500 font-bold">{item.rating}</span>
                      <span className="text-[10px] text-foreground-600">{item.meta}</span>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}